import React from 'react';
import {
  Button,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
  Box,
} from '@mui/material';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import BancameAlert from '../Alert';
import bancoBice from './enums';
import AlertDialog from '../AlertDialog';
import analytics from '../../utils/analytics';

function TransferDetailsDialog() {
  const theme = useTheme();

  const copyTextToClipboard = () => {
    analytics.track('Click Boton', {
      text: 'Copiar',
      initiator: 'usuario',
    });
    navigator.clipboard.writeText(
      `Bancame Trust Spa
      77.673.115-3
      Banco BICE
      Cuenta Corriente
      01-38366-3
      info@banca.me`,
    );
  };

  return (
    <AlertDialog
      pageCall={{
        category: 'PU - TU CREDITO',
        name: 'DATOS DE PAGO',
      }}
      maxWidth="lg"
      button={(
        <Button
          variant="outlined"
          color="primary"
        >
          Datos de pago
        </Button>
      )}
      dialogTitle={(
        <DialogTitle
          style={{ textAlign: 'left' }}
        >
          Datos para la transferencia
        </DialogTitle>
      )}
      hideSubmitButton
      dialogContent={(
        <Box>
          <Typography
            variant="body1"
            fontWeight="bold"
            align="left"
            gutterBottom
          >
            Datos bancarios
          </Typography>
          <Grid
            container
            sx={{
              alignItems: 'center',
              borderRadius: '15px',
            }}
            justifyContent="center"
          >

            <Grid
              item
              xs={12}
            >

              <Typography
                variant="body1"
                align="left"
                gutterBottom
              >
                {bancoBice.name.value}
              </Typography>
              <Divider />
              {Object.keys(bancoBice).map((key) => (
                key !== 'name'
                && (
                  <div key={key} style={{ display: 'flex', placeContent: 'space-between' }}>
                    <Typography
                      variant="body2"
                      align="left"
                    >
                      {bancoBice[key].label}
                      :
                    </Typography>
                    <Typography
                      variant="body2"
                      align="right"
                      fontWeight="bold"
                    >
                      {bancoBice[key].value}
                    </Typography>
                  </div>
                )
              ))}
              <Divider />
            </Grid>
            <Grid item xs={2}>
              <BancameAlert
                button={(
                  <IconButton
                    onClick={copyTextToClipboard}
                    size="large"
                  >
                    <Tooltip
                      title="Copiar datos"
                    >
                      <FileCopyOutlinedIcon style={{ color: theme.palette.grey[600], fontSize: '40px' }} />
                    </Tooltip>
                  </IconButton>
                )}
                successMessage="Has copiado los datos con éxito"
                errorMessage="Ha ocurrido un error copiando el texto"
                action={copyTextToClipboard}
              />

            </Grid>
          </Grid>
        </Box>
      )}
    />
  );
}

export default TransferDetailsDialog;
